import React from 'react';
import { useLocation } from 'react-router-dom';
import { useGetAllDealsQuery, useGetAllContactsQuery, useGetAllCompaniesQuery } from '../state/api';
import { CircularProgress, Box, List, ListItem, ListItemText, Paper, Typography, Divider } from '@mui/material';
import { useNavigate } from "react-router-dom";
import FlexBetween from "components/FlexBetween";
import Header from "components/Header";

const ResultsPage = () => {
    const location = useLocation();
    const searchTerm = location.state?.searchTerm;
    const { data: deals, isLoading: isLoadingDeals } = useGetAllDealsQuery(searchTerm);
    const { data: companies, isLoading: isLoadingCompanies } = useGetAllCompaniesQuery(searchTerm);
    const { data: contacts, isLoading: isLoadingContacts } = useGetAllContactsQuery(searchTerm);

    console.log("Search term:", searchTerm);
    console.log("Deals data:", deals);
    console.log("Companies data:", companies);
    console.log("Contacts data:", contacts);

    const navigate = useNavigate();

    // Navigate to detail page for each category (assuming similar functionality for companies and contacts)
    const handleItemClick = (item, category) => {
        if (category === 'deal') {
            navigate(`/deal-details`, { state: { deal: item, searchTerm } });
        } else {
            const baseUrl = 'https://flairflow.salesmate.io/#/app/';
            const detailUrl = category === 'contact' ? 
                `${baseUrl}contacts/${item.id}/detail?source=18fd0eed-6f34-4918-997c-2c8e832a38ba` :
                `${baseUrl}companies/${item.id}/detail?source=90b0601d-b00c-4a23-a7a1-a9ea1b827616`;
            window.open(detailUrl, '_blank');
        }
    };

    // Check if all categories are still loading
    if (isLoadingDeals || isLoadingCompanies || isLoadingContacts) {
        return <CircularProgress />;
    }

    const filterDeals = (dealsData, term) => {
        if (!dealsData.deals) return [];
        return dealsData.deals.filter(deal =>
            (deal.title && deal.title.toLowerCase().includes(term.toLowerCase())) ||
            (deal.primaryContact && deal.primaryContact.name && deal.primaryContact.name.toLowerCase().includes(term.toLowerCase()))
        );
    };

    const filterContacts = (contactsData, term) => {
        if (!contactsData.contacts) return [];
        return contactsData.contacts.filter(contact =>
            (contact.name && contact.name.toLowerCase().includes(term.toLowerCase())) ||
            (contact.company && contact.company.name && contact.company.name.toLowerCase().includes(term.toLowerCase()))
        );
    };

    const filterCompanies = (companiesData, term) => {
        if (!companiesData.companies) return [];
        return companiesData.companies.filter(company =>
            (company.name && company.name.toLowerCase().includes(term.toLowerCase())) ||
            (company.email && company.email.toLowerCase().includes(term.toLowerCase()))
        );
    };

    const filteredDeals = filterDeals(deals, searchTerm);
    const filteredCompanies = filterCompanies(companies, searchTerm);
    const filteredContacts = filterContacts(contacts, searchTerm);

    console.log("Filtered Deals:", filteredDeals);
    console.log("Filtered Companies:", filteredCompanies);
    console.log("Filtered Contacts:", filteredContacts);

    // Check if there are no results for all categories
    if (filteredDeals.length === 0 && filteredCompanies.length === 0 && filteredContacts.length === 0) {
        return <Typography m="1.5rem 2.5rem">No results found for "{searchTerm}"</Typography>;
    }

    return (
        <Box>
            <FlexBetween m="1.2rem 2.5rem">
                <Header title="Results" subtitle="" />
            </FlexBetween>
            <Typography m="0rem 2.5rem"> Found: {filteredDeals.length} Deals | {filteredContacts.length} Contacts | {filteredCompanies.length} Companies</Typography>
            <Paper elevation={3} style={{ padding: '1.5rem', margin: '20px' }}>
                <Header title="" subtitle="Deals" />
                {filteredDeals.length > 0 && (
                    <List>
                        {filteredDeals.map((deal, index) => (
                            <>
                            <ListItem key={index} button onClick={() => handleItemClick(deal, 'deal')}>
                                <ListItemText primary={`${deal.title}`} secondary={`ID: ${deal.id}`} />
                            </ListItem>
                            <Divider variant="middle" style={{ margin: '2px 0' }} />
                            </>
                        ))}
                    </List>
                )}
            </Paper>
            <Paper elevation={3} style={{ padding: '1.5rem', margin: '20px' }}>
                <Header title="" subtitle="Contacts" />
                {filteredContacts.length > 0 && (
                    <List>
                        {filteredContacts.map((contact, index) => (
                            <>
                            <ListItem key={index} button onClick={() => handleItemClick(contact, 'contact')}>
                                    <ListItemText primary={`${contact.name}`} secondary={`${contact.email}`} />
                                    <ListItemText primary={``} secondary={`${contact.mobile}`} />
                            </ListItem>
                            <Divider variant="middle" style={{ margin: '2px 0' }} />
                            </>
                        ))}
                    </List>
                )}
            </Paper>
            <Paper elevation={3} style={{ padding: '1.5rem', margin: '20px' }}>
                <Header title="" subtitle="Companies" />
                {filteredCompanies.length > 0 && (
                    <List>
                        {filteredCompanies.map((company, index) => (
                            <>
                            <ListItem key={index} button onClick={() => handleItemClick(company, 'company')}>
                                <ListItemText primary={`${company.name}`} secondary={`ID: ${company.id}`} />
                            </ListItem>
                            <Divider variant="middle" style={{ margin: '2px 0' }} />
                            </>
                        ))}
                    </List>
                )}
            </Paper>
        </Box>
    );

};

export default ResultsPage;
